// src/components/job-engine/formatters.ts
import type { JobState } from "@/api/jobEngine";

/**
 * Renders a UTC ISO timestamp from the API in the user's LOCAL timezone with
 * a short timezone abbreviation (e.g., "10/25/2026, 03:14:22 PM EDT"). The
 * input must be a UTC ISO string with a 'Z' suffix; new Date(...) correctly
 * parses that and toLocaleString converts to local for display.
 */
export const formatDateTime = (iso: string | null): string => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  });
};


export const formatDuration = (startIso: string | null, endIso: string | null): string => {
  if (!startIso || !endIso) return "—";
  const ms = new Date(endIso).getTime() - new Date(startIso).getTime();
  if (!Number.isFinite(ms) || ms < 0) return "—";
  const totalSec = Math.round(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
};

const STATE_COLOR: Record<JobState, string> = {
  Enqueued:     "#605e5c",
  Started:      "#0078d4",
  Succeeded:    "#107c10",
  Failed:       "#d13438",
  DeadLettered: "#a80000",
};

export const stateColor = (state: JobState): string => STATE_COLOR[state];
export const stateLabel = (state: JobState): string => state;
